import { ReactNode } from 'react';

import { FormikTextField } from '@frontend/components';
import { tAuth } from '@frontend/locales';

export interface FormikEmailFieldProps {
  name?: string;
  label?: string;
  required?: boolean;
  helperText?: string;
  errorText?: string;
  fullWidth?: boolean;
  autoComplete?: string;
  endAdornment?: ReactNode;
  disabled?: boolean;
}

export const FormikEmailField = (props: FormikEmailFieldProps) => {
  return (
    <FormikTextField
      autoComplete="email"
      type="email"
      name="email"
      inputMode="email"
      label={tAuth.fields.emailAddress()}
      errorText={tAuth.fieldErrors.invalidEmail()}
      {...props}
    />
  );
};
